import { render, staticRenderFns } from "./tianp.vue?vue&type=template&id=707b36b0&scoped=true&"
import script from "./tianp.vue?vue&type=script&lang=js&"
export * from "./tianp.vue?vue&type=script&lang=js&"
import style0 from "./tianp.vue?vue&type=style&index=0&id=707b36b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b36b0",
  null
  
)

export default component.exports